import { useMutation } from '@libs/use';
import { DirectDebitRequest } from '@libs/api-reference';

import * as API from '../requests';

export default function useCreateDirectDebitQuery({ onSuccess, onReject }) {
  const {
    execute: createDirectDebit,
    isPending: isCreateDirectDebit,
    ...query
  } = useMutation(
    (formModel: DirectDebitRequest) => API.directDebit(formModel),
    {
      onSuccess,
      onReject,
    }
  );

  return { createDirectDebit, isCreateDirectDebit, ...query };
}
